import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import hu from './locales/hu.json';
import en from './locales/en.json';
import de from './locales/de.json';

// Keys are organized by feature/component to keep things maintainable.
// Loaded from external locale JSON files to keep source tidy.
const resources2 = {
  hu: { translation: hu },
  en: { translation: en },
  de: { translation: de }
};
// Language detector order: querystring (lang), localStorage, navigator
const detectionOptions = {
  order: ['querystring', 'localStorage', 'navigator'],
  lookupQuerystring: 'lang',
  lookupLocalStorage: 'i18nextLng',
  caches: ['localStorage'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources2,
    fallbackLng: 'hu',
    supportedLngs: ['hu', 'en', 'de'],
    detection: detectionOptions,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    returnObjects: true,
  });

export default i18n;
